import { createFileRoute } from "@tanstack/react-router";

import { defineHead } from "../-common";

import { ServiceCategoriesPage } from "~/pages/admin-panel";
import { Tk } from "~/shared/i18n";

export const Route = createFileRoute("/{-$locale}/admin-panel/service-categories")({
  head: defineHead({
    titleT: {
      key: Tk.CATEGORY,
      options: {
        count: 2,
      },
    },
  }),
  component: ServiceCategoriesPage,
});
